<template>
  <v-layout justify-center>
    <v-flex >
      <panel :title="$t('buildingDetails.createBuilding')">
        <v-text-field
          :label="$t('buildingGenerics.buildingName')"
          required
          :rules="[required]"
          v-model="building.building_name"
        ></v-text-field>
        <v-text-field
          :label="$t('buildingGenerics.buildingDescr')"
          required
          :rules="[required]"
          v-model="building.description"
        ></v-text-field>
        <v-select
          v-model="building.site_id"          
          :items="sites"
          item-text="site_name"
          item-value="site_id"
          :label="$t('siteGenerics.siteName')">
        </v-select>
        <div class="danger-alert" v-if="error">
          {{error}}
        </div>
        <v-btn
          dark
          class="secondary"
          @click="create">
          {{$t('buildingDetails.createBuilding')}}
        </v-btn>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import BuildingsApi from '@/api/buildings-api'
import SitesService from '@/services/SitesService'

export default {
  data () {
    return {
      building: {
        building_name: null,
        description: null,
        site_id: null
      },
      error: null,
      result: null,
      required: (value) => !!value || 'Required.',
      sites: []
    }
  },
  methods: {
    async create () {
      this.error = null
      const areAllFieldsFilledIn = Object
        .keys(this.building)
        .every(key => !!this.building[key])
      if (!areAllFieldsFilledIn) {
        this.error = this.$t('mainErrors.fieldsRequired')
        return
      }

      try {
        this.result = (await BuildingsApi.post(this.building))
        if(this.result.status !== 200) {
          throw new Error(this.result.data)
        }
        this.$emit('close')
      } catch (error) {
        this.error = error
        console.log(error)
      }
    }
  },
  async mounted () {
    try {
      this.sites = (await SitesService.index()).data
    } catch (error) {
      this.error = error.response.data.error.message
      console.log(error)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CreateBuilding.vue